{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome-utvidelsen er ikke installert.",
      "CTA": "Installer utvidelse"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Historikk"
    },
    "HISTORY": {
      "OPEN": "Åpne",
      "RECENT": "Nylige",
      "MISSED": "Tapte",
      "LOADING": "Laster anrop...",
      "EMPTY": "Ingen anrop her",
      "ERROR": "Kunne ikke laste inn anropene",
      "CALL": "Ring tilbake",
      "CALL_STATUS": {
        "BUTTON": "Angi anropsstatus",
        "TITLE": "Anropsstatus",
        "SEARCH_PLACEHOLDER": "Søk i statuser...",
        "LOADING": "Laster statuser...",
        "NO_OPTIONS": "Ingen anropsstatuser er konfigurert",
        "NO_MATCH": "Ingen samsvarende status",
        "OPTIONS_ERROR": "Kunne ikke laste inn statusene",
        "RETRY": "Prøv igjen",
        "CONFIRM_QUESTION": "Angi «{status}» og løs samtalen?",
        "CONFIRM": "Bekreft",
        "BACK": "Tilbake",
        "CANCEL": "Avbryt",
        "SAVING": "Lagrer...",
        "SAVE_ERROR": "Kunne ikke lagre statusen",
        "RESOLVE_ERROR": "Status lagret, men samtalen kunne ikke løses"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefonnummer, f.eks. +421903000000",
      "BODY_PLACEHOLDER": "Skriv meldingen din ...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Send SMS",
      "SENDING": "Sender ...",
      "SENT": "SMS sendt",
      "LOADING": "Laster SMS-innbokser ...",
      "NO_INBOX": "Denne kontoen har ingen SMS-innboks, så SMS kan ikke sendes.",
      "INVALID_NUMBER": "Skriv nummeret i internasjonalt format, inkludert + foran.",
      "ERROR": "SMS-en kunne ikke sendes. Prøv igjen."
    },
    "ACTIONS": {
      "CONNECT": "Koble til",
      "GO_TO_TAB": "Gå til den fanen",
      "DISCONNECT": "Koble fra",
      "ANSWER": "Svar",
      "HANGUP": "Legg på",
      "HOLD": "Sett på vent",
      "MUTE": "Demp mikrofon",
      "SILENCE": "Demp lyd",
      "TRANSFER": "Overfør",
      "COMPLETE_TRANSFER": "Fullfør overføring",
      "RETURN_TO_CALLER": "Tilbake til innringer",
      "CANCEL_TRANSFER": "Avbryt overføring",
      "DIALPAD": "Vis nummertastatur",
      "OPEN_CONVERSATION": "Åpne samtale"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Innkommende anrop",
      "INCOMING_CALL_FROM": "Innkommende anrop fra {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Innkommende anrop fra {number}",
      "ANSWER": "Svar",
      "DECLINE": "Avvis"
    },
    "TRANSFER": {
      "TITLE": "Overfør anrop",
      "PLACEHOLDER": "Angi målnummer for overføring...",
      "SEARCH_PLACEHOLDER": "Søk etter agenter...",
      "TARGET_PLACEHOLDER": "Valgt overføringsmål",
      "CONFIRM": "Overfør",
      "MODE_DIRECT": "Overfør nå",
      "MODE_CONSULT": "Ring agent først",
      "CANCEL": "Avbryt"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Er du sikker på at du vil ta pause for alle køer?",
      "CONFIRM_READY": "Er du sikker på at du vil gå tilbake til klar-status for alle køer?",
      "CONFIRM_BREAK_QUEUE": "Er du sikker på at du vil logge ut av køen {queue}?",
      "CONFIRM_READY_QUEUE": "Er du sikker på at du vil logge inn i køen {queue}?",
      "LOGIN_TO_QUEUE": "Logg inn",
      "LOGOUT_FROM_QUEUE": "Logg ut",
      "LOGIN_TO_ALL_QUEUES": "Logg inn i alle køer",
      "LOGOUT_FROM_ALL_QUEUES": "Logg ut av alle køer",
      "OPTION_LOGOUT": "Logg ut",
      "OPTION_BREAK": "Pause",
      "OPTION_LUNCH": "Lunsj",
      "OPTION_AWAY": "Borte",
      "OPTION_DO_NOT_DISTURB": "Ikke forstyrr",
      "OPTION_BUSINESS_TRIP": "Tjenestereise",
      "CONFIRM": "Bekreft",
      "CANCEL": "Avbryt"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Ingen tilkobling til telefonsystemet",
      "MESSAGE": "Internettforbindelsen din ser ut til å være nede. Sjekk den og prøv igjen.",
      "CREDENTIALS_TITLE": "Telefonsystemet avviste legitimasjonsopplysningene dine",
      "CREDENTIALS_MESSAGE": "Telefonsystemet avviste brukernavnet eller passordet som er lagret i profilen din. Sjekk dem i Brukerinnstillinger, eller spør administratoren din.",
      "CONFIGURATION_TITLE": "Telefoninnstillingene er ugyldige",
      "CONFIGURATION_MESSAGE": "SIP-brukernavnet eller serveradressen er ikke i et gyldig format, så telefonen kan ikke koble til. Rett det i Brukerinnstillinger.",
      "NETWORK_SHORT": "Tilkobling mislyktes",
      "CREDENTIALS_SHORT": "Legitimasjon avvist",
      "CONFIGURATION_SHORT": "Ugyldige telefoninnstillinger",
      "RETRY": "Prøv igjen",
      "DISMISS": "Avbryt"
    },
    "CONNECTION_QUALITY": "Tilkoblingskvalitet",
    "CONNECTION_QUALITY_EXCELLENT": "Utmerket",
    "CONNECTION_QUALITY_GOOD": "God",
    "CONNECTION_QUALITY_FAIR": "Middels",
    "CONNECTION_QUALITY_POOR": "Dårlig",
    "CONNECTION_QUALITY_DISCONNECTED": "Frakoblet",
    "STATUS": {
      "OFFLINE": "Telefon frakoblet",
      "IN_OTHER_TAB": "Telefonen er koblet til i en annen fane",
      "CONNECTING": "Kobler til...",
      "DISCONNECTING": "Kobler fra...",
      "ONLINE": "Telefon tilkoblet",
      "DIALING": "Ringer",
      "TRANSFERRING": "Overfører...",
      "CONSULTING": "Snakker med agent",
      "CALLER_ON_HOLD": "Innringeren er satt på vent",
      "BUSY": "Opptatt",
      "DND": "DND",
      "UNAVAILABLE": "Utilgjengelig",
      "REJECTED": "Anrop avvist",
      "CALL_FAILED": "Anrop mislyktes"
    },
    "QUEUES": {
      "MORE": "Flere køer"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Ringer {number}… Du kan lukke denne fanen.",
    "NO_NUMBER": "Ingen nummer oppgitt. Bruk ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Skriv inn telefonnummer...",
    "ACTIONS": {
      "DIAL": "Ring nummer",
      "DIAL_FROM": "Velg nummeret du ringer fra"
    },
    "DIAL_FROM": {
      "TITLE": "Ring fra nummeret til en innboks"
    },
    "VALIDATION": {
      "REQUIRED": "Telefonnummer er påkrevd",
      "INVALID_FORMAT": "Ugyldig format på telefonnummer"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Lydinnstillinger og testing",
    "SELECT_DEVICE": "Velg enhet...",
    "SYSTEM_DEFAULT": "Systemstandard",
    "SAVED": "Lagret",
    "DISCONNECTED_SUFFIX": "ikke tilkoblet",
    "DEVICE_DISCONNECTED": "Den valgte enheten er ikke tilkoblet. Samtaler bruker systemstandarden til den er tilbake.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Test mikrofon",
      "STOP_TEST": "Stopp test",
      "LEVEL": "Nivå:",
      "VERDICT": {
        "LISTENING": "Si noe inn i mikrofonen…",
        "SILENT": "Du blir ikke hørt. Sjekk at mikrofonen er på, og at riktig mikrofon er valgt.",
        "LOW": "Du høres bare svakt. Velg en annen mikrofon eller juster inngangsvolumet i systeminnstillingene.",
        "GOOD": "God lyd — du høres godt."
      }
    },
    "SPEAKER": {
      "TITLE": "Høyttaler",
      "TEST": "Test høyttaler",
      "TESTING": "Tester...",
      "VOLUME": "Volum:",
      "USING_DEFAULT": "Valgt utgang er ikke tilgjengelig — spilt av på systemstandarden."
    },
    "DONE": "Ferdig",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Feil ved tilgang til mikrofonen. Sjekk tillatelsene.",
      "MICROPHONE_PERMISSION_DENIED": "Tilgang til mikrofonen er blokkert. Tillat dette i nettleserens nettstedsinnstillinger for å bruke telefonen.",
      "MICROPHONE_SILENT": "Mikrofonen din fanger ikke opp noen lyd. Sjekk lydinnstillingene dine.",
      "EXTENSION_REQUIRED": "Telefonutvidelsen ble ikke oppdaget. Installer eller aktiver den for å bruke mikrofonen.",
      "SPEAKER_TEST": "Feil ved testing av høyttalerutgang."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Frakoblet",
    "ONLINE": "Pålogget",
    "BUSY": "Opptatt"
  },
  "QUEUE_STATUS": {
    "READY": "Klar",
    "NOT_READY": "Tar ikke imot anrop",
    "WRAP_UP": "Etterarbeid",
    "BREAK": "Pause",
    "LUNCH": "Lunsj",
    "AWAY": "Borte",
    "DO_NOT_DISTURB": "Ikke forstyrr",
    "BUSINESS_TRIP": "Tjenestereise",
    "OTHER_CALL": "Annet anrop",
    "QUEUE_CALL": "Køanrop",
    "OFFLINE": "Frakoblet",
    "ONLINE": "Pålogget",
    "NO_ACCESS": "Ingen telefon",
    "PARTIALLY_READY": "Delvis klar",
    "MIXED": "Blandet",
    "CHAT_ONLINE": "Pålogget (chat)",
    "CHAT_BUSY": "Opptatt (chat)",
    "CHAT_OFFLINE": "Frakoblet (chat)"
  }
}
